export default function(h, row, index) {
    if (row.m_disabled)
        return <i class="fa fa-pause-circle-o fa-lg text-danger" title="объект отключен"></i>
    else
        return <i class="fa fa-play-circle-o fa-lg text-success" title="объект активен"></i>
}